
import { BlogPost } from "@/types/blog";
import { content } from "./content";

export const NeuroplastizitaetEpigenetik: BlogPost = {
  title: "Neuroplastizität & Epigenetik: So formst du dein Gehirn aktiv mit",
  metaTitle: "Neuroplastizität & Epigenetik: Gehirn formen",
  excerpt: "Entdecke, wie Neuroplastizität und Epigenetik dein Gehirn und deine Gene beeinflussen – für geistige Fitness und persönliches Wachstum.",
  date: "14.03.2025",
  slug: "neuroplastizitaet-epigenetik",
  author: 'Jörg Hörmann',
  authorTitle: 'Finanz- & Executive Coach',
  imageUrl: "/lovable-uploads/47d75f6c-a103-4e44-8282-7267e37e5d92.png",
  category: "Coaching-Philosophie",
  tags: ["Neuroplastizität", "Epigenetik", "Gehirn", "Persönlichkeitsentwicklung", "Wissenschaft"],
  content
};
